module.exports = __webpack_public_path__ + "img/cart-list-bg.355ffbe7.png";